// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_010c285f","outerContainer":"_13aec3c2","secondaryToolbar":"_610b7843","doorHangerRight":"_4c7f0142","toolbarContainer":"_5ecf7410","toolbarViewerMiddle":"ba922e34","progressBar":"_2ded16a0","back-to-application":"_3d5693fc","hidden":"c7af3e06","root":"_6450ee66","fullScreenContainer":"_4250fe02"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/OpentokVideo/styles.styl
// module id = 5169
// module chunks = 39